/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 7:56 AM
 *
 */

import MemberOtherDetailModal from 'features/members/components/others/MemberOtherDetailModal/MemberOtherDetailModal';

export default MemberOtherDetailModal;
